import { useState, useEffect } from 'react';

/**
 * Custom hook to track scroll position and determine if an element should be sticky
 * @param {number} threshold - Scroll position in pixels when element should become sticky
 * @returns {boolean} Whether the scroll position is past the threshold
 */
export const useScrollPosition = (threshold: number = 0): boolean => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  
  useEffect(() => {
    const handleScroll = (): void => {
      setIsScrolled(window.scrollY > threshold);
    };
    
    // Add scroll listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check in case page is already scrolled
    handleScroll();
    
    // Clean up
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);
  
  return isScrolled;
};
